define(
	'AAMedical.ScopeRepair.ServiceYourScope.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils) {
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function ServiceYourScopeModel() {
			SCModel.call(this);

			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath('services/ServiceYourScope.Service.ss')
				);
			};

			this.validation = function() {
				return {
					businessname: {
						required: true,
						msg: Utils.translate('Business Name is required')
					},
					firstname: {
						required: true,
						msg: Utils.translate('First Name is required')
					},
					lastname: {
						required: true,
						msg: Utils.translate('Last Name is required')
					},
					email: [
						{
							required: true,
							msg: Utils.translate('Email is required')
						},
						{
							pattern: 'email',
							msg: Utils.translate('Valid email address is required')
						}
					],
					phone: {
						required: true,
						msg: Utils.translate('Phone is required')
					},
					model: {
						required: true,
						msg: Utils.translate('Model # is required')
					},
					manufacturer: {
						required: true,
						msg: Utils.translate('Manufacturer is required')
					},
					concerns: {
						required: true,
						msg: Utils.translate('Please describe your concerns with the scope')
					}
				};
			};
		}

		ServiceYourScopeModel.prototype = Object.create(SCModel.prototype);
		ServiceYourScopeModel.prototype.constructor = ServiceYourScopeModel;

		return ServiceYourScopeModel;
	}
);
